// API base URL helper. Local dev: empty (Vite proxy forwards /api -> :8787).
// Production: Pages and Worker live on different subdomains, so we prepend
// the absolute worker URL set via VITE_API_BASE.

const BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';

export function apiUrl(path: string): string {
  return BASE + path;
}

export function wsUrl(path: string): string {
  if (!BASE) {
    const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${proto}//${window.location.host}${path}`;
  }
  // Convert https://... to wss://..., http://... to ws://...
  return BASE.replace(/^http/, 'ws') + path;
}
